"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLicenseState = void 0;
const activities_1 = require("../../api/activities");
const LicenseState_1 = require("../../common/js/enums/LicenseState");
const useHasConsentQuery_1 = require("../../common/js/queries/useHasConsentQuery");
const useHasTopicQuery_1 = require("../../common/js/queries/useHasTopicQuery");
const useLicenseState = (license) => {
    const { data: hasActivation, isFetching: isFetchingActivation } = (0, useHasTopicQuery_1.useHasTopicQuery)(activities_1.ActivityTopic.ConsentActivateLicense, license, { enabled: !license.activated });
    const { data: hasConsent, isFetching: isFetchingConsent } = (0, useHasConsentQuery_1.useHasConsentQuery)(license, {
        enabled: !license.activated && !isFetchingActivation && !hasActivation,
    });
    if (license.activated || hasActivation) {
        return { state: LicenseState_1.LicenseState.Active, isFetching: false };
    }
    if (isFetchingActivation || isFetchingConsent) {
        return { isFetching: true };
    }
    if (hasConsent) {
        return { state: LicenseState_1.LicenseState.ConsentGiven, isFetching: false };
    }
    return { state: LicenseState_1.LicenseState.Inactive, isFetching: false };
};
exports.useLicenseState = useLicenseState;
